<template>
    <div class="login_menu">
        <navTop :isLogin="1" :title="msg"></navTop>
        <div class="newLomk">
            <div class="loginMen_all">

                <div class="cov_left">
                    <div class="btnRu">快捷入口</div>
                    <el-collapse accordion v-for="(item,index) in bandner" :key="index" @change="handlCheckMenu(index)"
                                 id="navLeft">
                        <el-collapse-item>
                            <template slot="title">
                                <div :class="bandnerActive == index ? 'btnSin' : ''">
                                    {{item.title}}
                                </div>
                            </template>
                            <div class="vip-down" @click="handlCheckTwoMenu(newIndex)"
                                 v-for="(newItem,newIndex) in item.list" :key="newIndex"
                                 :class="bandnerTwoActive == newIndex ? 'vip-downActive' : ''">
                                {{newItem.text}}
                            </div>
                        </el-collapse-item>
                    </el-collapse>
                </div>
                <div class="right">
                    <router-view @test="testNN"></router-view>
                </div>
            </div>
        </div>
        <navBom></navBom>
    </div>
</template>

<script>
    import navTop from './nav-top.vue'
    import navBom from './nav-bom.vue'

    export default {
        components: {
            navTop,
            navBom
        },
        data() {
            return {
                bandner: [
                    {
                        title: '合同签署',
                        list: [
                            // {
                            //     text: '立即签署合同',
                            // },
                            {
                                text: '系统模板',
                            },
                            {
                                text: '自建模板',
                            },
                            {
                                text: '离线签署',
                            },
                        ]
                    },
                    {
                        title: '签章验证'
                    },
                    {
                      title: 'Ukey'
                    },

                    {
                        title: '会员中心'
                    },
                ],
                bandnerActive: null,
                bandnerTwoActive: null,
                msg: ''
            }
        },
        mounted() {
            this.handlCheckMenu(this.$route.query.active);
        },
        methods: {
            testNN(msg) {
                this.msg = msg;
            },
            handlRouter(name) {
                this.$router.push({
                    path: '/' + name
                });
            },
            handlRouterX(name) {
                this.$router.push({
                    name: name,
                    params: {
                        state: 0
                    }
                });
            },
            handlCheckMenu(index) {
                this.bandnerActive = index;
                if (!this.$global.webData.type) {
                    this.$message.info('请先进行认证');
                    this.$router.push('authen');
                    return
                }
                if (index == 0) {
                    this.handlRouter('contractSin');
                } else if (index == 1) {
                    // this.handlRouter('signInsp');
                  this.handlRouter('youKe');

                } else if (index == 2) {
                    this.handlRouter('ukeyList');

                }   else if (index == 3) {
                  this.handlRouter('vipCenter');
                }
            },
            handlCheckTwoMenu(index) {
                this.bandnerTwoActive = index;
                if (!this.$global.webData.type) {
                    this.$message.info('请先进行认证');
                    this.$router.push('authen');
                    return
                }
                if (index == 0) {
                  this.handlRouter('Contemplate');
                } else if (index == 1) {
                  this.handlRouter('myTemplate');
                } else if (index == 2) {
                  this.handlRouter('OfflineSin');
                } else {
                  this.handlRouter('Contemplate');
                }
            }
        }
    }
</script>

<style scoped lang="less">
    @import '../../../static/less/xm.less';

    /deep/ .el-collapse-item__arrow {
        display: none;
    }

    /deep/ .el-collapse-item__content {
        padding: 0;
    }

    /deep/ .el-collapse {
        border: 1px solid #EBEEF5;
    }

    #navLeft /deep/ .el-collapse-item__header {
        width: auto;
        height: 81px;
        background-color: #fff;
        text-align: center;
        letter-spacing: 1px;
        color: #333333;
        font-size: 24px;
        @row();
    }

    #navLeft /deep/ .el-collapse-item__header:hover {
        background-image: linear-gradient(270deg,
        #1e6eee 0%,
        #109ee7 50%,
        #01cee0 100%),
        linear-gradient(#000000,
        #000000);
        background-blend-mode: normal,
        normal;
        box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
        color: #fff;
    }

    .login_menu {
        width: auto;
        height: auto;

        .newLomk {
            width: @a;
            height: auto;
            @row();

            .loginMen_all {
                width: 1410px;
                height: auto;
                display: @flex;
                justify-content: center;
                padding: 2% 0;

                .cov_left {
                    width: 280px;
                    height: auto;
                    padding: 0 2px;

                    .btnRu {
                        width: 277px;
                        height: 110px;
                        line-height: 110px;
                        text-align: center;
                        background-color: #f5f5f5;
                        letter-spacing: 2px;
                        color: #333333;
                        font-family: MicrosoftYaHei-Bold;
                        font-size: 30px;
                        font-weight: normal;
                        font-stretch: normal;
                    }

                    .btnSin {
                        width: @a;
                        height: @a;
                        @row();
                        text-align: center;
                        background-image: linear-gradient(270deg,
                        #1e6eee 0%,
                        #109ee7 50%,
                        #01cee0 100%),
                        linear-gradient(#000000,
                        #000000);
                        background-blend-mode: normal,
                        normal;
                        box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                        cursor: pointer;
                        color: #fff !important;

                    }

                    .vip-down {
                        width: auto;
                        height: 61px;
                        text-align: center;
                        line-height: 61px;
                        background-color: #f5f5f5;
                        border: solid 1px #aaaaaa;
                        font-size: 18px;
                        letter-spacing: 1px;
                        color: #333333;
                        margin: -1px;
                        cursor: pointer;
                    }

                    .vip-downActive {
                        background-color: #dddddd;
                    }
                }

                .right {
                    width: calc(@a - 280px);
                    // width: @a;
                    height: auto;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/nav/nav-left.vue